import React, { useState, useEffect } from 'react';
import { useStore } from '../../context/store';


export default function FilterRange( props ) {
    const {
        state,
        dispatch,
    } = useStore();

    const pre = 'ygl-filter-range';

    if ( 'undefined' !== props.filter ) {
        const filter = props.filter;

        const selectMinValue = 'undefined' !== typeof state.filters[ filter.min_option.field ] 
            ? state.filters[ filter.min_option.field ]
            : ''
        
        const selectMaxValue = 'undefined' !== typeof state.filters[ filter.max_option.field ] 
            ? state.filters[ filter.max_option.field ]
            : ''

        return (
            <div className={`ygl-filter ${pre}`}>
                <div className={`${pre}__title`} onClick={ e => props.toggleParentActiveClass( e ) }>{filter.name}</div>

                <div className={`${pre}__dropdown`}>
                    <div className={`${pre}__range`}>
                        <div className={`${pre}__min-container`}>
                            <label>{filter.min_option.name}</label>

                            <select 
                                className={`${pre}__select`} 
                                onChange={ (e) => dispatch({
                                    type: 'setFilter', 
                                    payload: {
                                        field: filter.min_option.field,
                                        value: e.target.value,
                                    }
                                }) }
                                value={ selectMinValue }
                            >
                                {filter.min_option.options.map((option, key) => {
                                    return (
                                        <option value={option.value ?? ''} key={ key }>{option.name}</option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className={`${pre}__separator`}>&mdash;</div>

                        <div className={`${pre}__max-container`}>
                            <label>{filter.max_option.name}</label>

                            <select 
                                className={`${pre}__select`} 
                                onChange={ (e) => dispatch({
                                    type: 'setFilter', 
                                    payload: {
                                        field: filter.max_option.field,
                                        value: e.target.value,
                                    }
                                }) }
                                value={ selectMaxValue }
                            >
                                {filter.max_option.options.map((option, key) => {
                                    return (
                                        <option value={option.value ?? ''} key={ key }>{option.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return '';
}